export default "__VITE_ASSET__45084577__"